import type { Organization } from './Organization'

// Returned instead of Organization when the Auth0 record doesn't satisfy
// the contract above (e.g. legacy organizations missing Branding).
export interface InvalidOrganization {
  Id?: string
  Name: string
  DisplayName: string
  Branding?: undefined
  Metadata?: undefined
  missingFields: string[]
}

export function isInvalidOrganization(
  org: Organization | InvalidOrganization,
): org is InvalidOrganization {
  return 'missingFields' in org
}
